import { createContext, useContext } from 'react';
import type { DeliveryMode } from '../api/endpoints';

/**
 * Отделы текущего пользователя (ADR-0030).
 *
 * Кабинет данные других отделов и так не получает — сервер фильтрует выдачу. Контекст
 * нужен формам: диспетчер курьерской службы не выбирает «дистрибуцию» в режиме заказа,
 * потому что сервер всё равно отклонит такой заказ, а узнавать об этом отказом —
 * хуже, чем не видеть варианта вовсе.
 */
export const DepartmentsContext = createContext<readonly DeliveryMode[]>([]);

export function useDepartments(): readonly DeliveryMode[] {
  return useContext(DepartmentsContext);
}
